import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

/**
 * Spanish translations for Material Paginator
 */
@Injectable()
export class SpanishPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  // Número de elementos por página
  itemsPerPageLabel = 'Elementos por página:';

  // Botón para ir a la siguiente página
  nextPageLabel = 'Siguiente página';

  // Botón para ir a la página anterior
  previousPageLabel = 'Página anterior';

  // Botón para ir a la primera página
  firstPageLabel = 'Primera página';

  // Botón para ir a la última página
  lastPageLabel = 'Última página';

  /**
   * Rango de elementos mostrados
   * Ejemplo: "1 - 10 de 100"
   */
  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return 'Página 1 de 1';
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Página ${page + 1} de ${amountPages}`;
  }
}
